const styles = (theme) => ({
  loadingDialog: {
    display: 'none',
  },
  dialogPaper: {
    [theme.breakpoints.up('sm')]: {
      maxHeight: 'calc(100% - 30px)',
      width: 560,
    },
  },
  closeModalContainer: {
    minHeight: theme.spacing.unit * 6,
  },
  titleContentContainer: {
    overflowY: 'auto',
  },
  dialogTitle: {
    textAlign: 'center',
    paddingTop: 0,
  },
  iconContainer: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 40,
    minHeight: 40,
    margin: '30px auto 10px',
    border: `2px solid ${theme.palette.primary.dark}`,
    borderRadius: '50%',
    [theme.breakpoints.up('sm')]: {
      minWidth: 67,
      minHeight: 67,
      margin: '50px auto 30px',
    },
  },
  icon: {
    color: theme.palette.border.dark,
    fontSize: '1.25rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.85rem',
    },
  },
  title: {
    fontSize: '2rem',
    fontWeight: '700',
    color: theme.palette.text.dark,
  },
  dialogContent: {
    overflowY: 'visible',
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
    '& a': {
      color: theme.palette.primary.dark,
      textDecoration: 'none',
    },
  },
  dialogText: {
    marginTop: theme.spacing.unit,
  },
  dialogActions: {
    display: 'block',
    textAlign: 'center',
    margin: `0 ${theme.spacing.unit * 3}px ${theme.spacing.unit * 2}px`,
  },
  button: {
    minWidth: 200,
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit,
  },
  firstButton: {
    marginTop: 0,
  },
  fieldContainer: {
    marginTop: theme.spacing.unit * 2,
  },
  divider: {
    margin: 0,
  },
  documentStyle: {
    fontSize: '1.1875rem',
    '& h4': {
      color: theme.palette.text.dark,
      fontFamily: 'Calibre',
      fontSize: '1.3125rem',
      lineHeight: 1.4115,
      marginBottom: '1em',
    },
    '& h4:first-child': {
      marginTop: '1em',
    },
    '& p': {
      marginTop: theme.spacing.unit * 3,
      marginBottom: theme.spacing.unit * 3,
    },
    '& p:last-child': {
      marginBottom: 0,
    },
    '& ul, & li': {
      textAlign: 'left',
    },
  },
  contactDetails: {
    marginTop: theme.spacing.unit * 4,
  },
  contactDetailsText: {
    marginBottom: theme.spacing.unit * 4,
  },
  profileFields: {
    margin: '0 auto',
    textAlign: 'left',
  },
  fieldGroup: {
    margin: '0 auto',
    position: 'relative',
  },
  field: {
    display: 'inline-block',
    verticalAlign: 'top',
  },
  fieldLabel: {
    fontWeight: 500,
  },
  edit: {
    position: 'absolute',
    right: 0,
    top: theme.spacing.unit,
    minWidth: theme.spacing.unit * 4,
  },
  editIcon: {
    fontSize: '1.5rem',
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing.unit,
    right: theme.spacing.unit,
    '& svg': {
      fontSize: '2.375rem',
      color: theme.palette.border.grey,
      width: '1em',
      height: '1em',
    },
  },
  progress: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    marginLeft: -25,
    marginTop: -25,
    '&:focus': {
      border: 'none',
      outline: 'none',
    },
  },
});

export default styles;
